import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import BgImg from "../../../assets-user/interior/InteriorBg.png";
import interiorDesignImg from "../../../assets-user/interior/InteriorDesign.png";

const DreamInteriorDesign = () => {
  useEffect(() => {
    AOS.init({
      duration: 900,
      once: true,
      easing: "ease-out-cubic",
    });
  }, []);

  return (
    <div
      className="w-full relative overflow-hidden px-4 sm:px-6 md:px-8 lg:px-10"
      data-aos="fade-up"
    >
      <div className="relative flex flex-col xl:flex-row justify-between mx-auto">
        {/* Left Content Section */}
        <div
          className="w-full lg:w-full xl:w-1/2 mb-4 sm:mb-6 md:mb-6 lg:mb-4 mt-4 sm:mt-6 md:mt-8 lg:mt-10"
          data-aos="fade-right"
        >
          <h2
            className="text-[20px] font-semibold font-[Poppins] leading-[150%] tracking-[0.01em] text-[#2F2F2F] sm:text-[24px] md:text-[28px] lg:text-[32px] mb-1 sm:mb-2 md:mb-3 lg:mb-4 w-full sm:w-[95%] md:w-[90%] lg:w-[45%] xl:w-[60%]"
            data-aos="fade-down"
          >
            Bring Your Dream Spaces to Life with LeadBook's Interior Designs
          </h2>

          <p
            className="text-xs sm:text-sm md:text-base lg:text-lg font-normal text-gray-500 leading-relaxed w-full sm:w-[95%] md:w-[90%] xl:w-[60%]"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            Discover a wide range of thoughtfully crafted interior design
            concepts for every corner of your home—living rooms, bedrooms,
            kitchens, and more. With LeadBook, you can select from our curated
            designs and personalize them with your choice of layouts, colors,
            and finishes. Create interiors that reflect your lifestyle, match
            your property, and fit perfectly within your budget.
          </p>
        </div>

        {/* Right Content Section with Images */}
        <div
          className="w-full lg:w-full xl:w-1/2 relative"
          data-aos="fade-left"
          data-aos-delay="300"
        >
          {/* For SM, MD and LG devices - show only interior design image */}
          <div className="xl:hidden" data-aos="zoom-in">
            <img
              src={interiorDesignImg}
              alt="Modern Kitchen Design"
              className="w-full h-auto object-cover rounded-lg"
            />
          </div>

          <div className="hidden xl:block relative rounded-2xl">
            <img
              src={BgImg}
              alt="Background"
              className="w-full h-auto xl:h-[450px] object-cover rounded-2xl"
              data-aos="fade-in"
            />

            {/* Kitchen Image */}
            <div className="absolute inset-0 flex items-center justify-center px-6 sm:px-8">
              <div
                className="bg-white rounded-lg shadow-lg w-full"
                style={{ transform: "translateX(-40%)" }}
                data-aos="zoom-in-up"
              >
                <div className="flex flex-col sm:flex-row gap-4 p-4">
                  <div className="w-full" data-aos="fade-right">
                    <img
                      src={interiorDesignImg}
                      alt="Modern Kitchen Design"
                      className="w-full object-cover rounded-lg"
                    />
                  </div>
                  <div
                    className="w-full flex flex-col justify-center"
                    data-aos="fade-left"
                  >
                    <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2 sm:mb-3">
                      Seamless Integration
                    </h3>
                    <p className="text-gray-500 text-sm sm:text-base">
                      Match your interior design with your new dream home
                      purchase from LeadBook.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DreamInteriorDesign;
